import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const CountdownTimer = ({
  order,
  compact = false,
  durationMinutes = 45,
  expiredMarkerClassName = '',
}) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (!order.createdAt) return;
    const fallbackMinutes = Math.max(1, Number(durationMinutes || 45));

    const calculateTimeLeft = () => {
      const now = new Date();
      const createdTime = new Date(order.createdAt);
      const scheduledDateTime =
        order?.delivery?.deliveryDateTime ||
        order?.fullOrderData?.delivery?.deliveryDateTime ||
        order?.deliveryDateTime ||
        '';

      let deliveryTime;
      if (scheduledDateTime) {
        deliveryTime = new Date(scheduledDateTime);
      } else {
        deliveryTime = new Date(createdTime.getTime() + fallbackMinutes * 60 * 1000);
      }

      if (Number.isNaN(deliveryTime.getTime()) || deliveryTime <= createdTime) {
        deliveryTime = new Date(createdTime.getTime() + fallbackMinutes * 60 * 1000);
      }

      // Se já passou do tempo de entrega, considera expirado
      if (now >= deliveryTime) {
        setIsExpired(true);
        setTimeLeft(0);
        return;
      }

      // Calcula tempo restante
      const remaining = deliveryTime - now;
      setTimeLeft(Math.floor(remaining / 1000)); // em segundos
      setIsExpired(false);
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [durationMinutes, order]);

  const formatTime = (seconds) => {
    if (seconds <= 0) return '00:00';

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  // Só mostra timer para pedidos em "preparing"
  if (order.status !== 'preparing') {
    return null;
  }

  if (isExpired) {
    return (
      <>
        {expiredMarkerClassName ? <span className={expiredMarkerClassName} aria-hidden="true" /> : null}
        <Box
          role="status"
          sx={{
            marginTop: '3px',
            width: '100%',
            boxSizing: 'border-box',
            backgroundColor: '#dc2626',
            color: '#fff',
            padding: compact ? '4px 8px' : '5px 8px',
            borderRadius: '999px',
            minHeight: compact ? 22 : 24,
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            sx={{ fontSize: compact ? '10px' : '11px', fontWeight: 'bold', lineHeight: 1 }}
          >
            ATRASADO
          </Typography>
        </Box>
      </>
    );
  }

  const isWarning = timeLeft <= 900; // 15 minutos = 900 segundos

  return (
    <Box
      sx={{
        marginTop: '3px',
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: isWarning ? '#ffeb3b' : '#4caf50',
        color: isWarning ? '#000' : '#fff',
        padding: compact ? '4px 8px' : '5px 8px',
        borderRadius: '999px',
        fontSize: compact ? '10px' : '11px',
        fontWeight: 'bold',
        minHeight: compact ? 22 : 24,
        minWidth: 0,
        textAlign: 'center',
        boxShadow: 'none',
        alignSelf: 'stretch',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontSize: compact ? '10px' : '11px', fontWeight: 'bold', lineHeight: 1 }}
      >
        {formatTime(timeLeft)}
      </Typography>
    </Box>
  );
};

export default CountdownTimer;
